import {
  Button,
  DefaultComponentProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FlexGrid,
  Link,
  Typography,
} from '@albo-ui/core';
import { useTranslator } from '../../providers/translator-provider';

export type TemporalBlockInfoDialogProps = {
  onClose: () => void;
  open: boolean;
} & DefaultComponentProps;

export const TemporalBlockInfoDialog = ({
  onClose,
  open,
  className,
  style,
}: TemporalBlockInfoDialogProps) => {
  const {
    ACCEPT,
    TEMPORAL_BLOCK,
    TEMPORAL_BLOCK_DESCRIPTION,
    TO_TRY_AGAIN,
    BUSINESS_HELP_EMAIL,
    IF_THE_PROBLEM_PERSISTS_CONTACT_US_IN,
    TEN_MINUTES,
  } = useTranslator();

  return (
    <Dialog className={className} style={style} onClose={onClose} open={open}>
      <DialogTitle>{TEMPORAL_BLOCK}</DialogTitle>
      <DialogContent>
        <FlexGrid container direction='column' spacing={3}>
          <FlexGrid item>
            <Typography variant='paragraph'>
              {TEMPORAL_BLOCK_DESCRIPTION}{' '}
              <span className='f-bold'>{TEN_MINUTES}</span> {TO_TRY_AGAIN}{' '}
            </Typography>
          </FlexGrid>
          <FlexGrid item container direction='column' spacing={1}>
            <FlexGrid item>{IF_THE_PROBLEM_PERSISTS_CONTACT_US_IN}</FlexGrid>
            <FlexGrid item>
              <Link underlined href={`mailto:${BUSINESS_HELP_EMAIL}`}>
                {BUSINESS_HELP_EMAIL}
              </Link>
            </FlexGrid>
          </FlexGrid>
        </FlexGrid>
      </DialogContent>
      <DialogActions>
        <FlexGrid
          container
          fullHeight
          fullWidth
          justify='space-between'
          alignItems='flex-end'
          style={{ marginTop: '20px' }}
        >
          <FlexGrid item style={{ marginLeft: 'auto' }}>
            <Button onClick={onClose} size='normal'>
              {ACCEPT}
            </Button>
          </FlexGrid>
        </FlexGrid>
      </DialogActions>
    </Dialog>
  );
};
